import { InvitationResponseDto } from '@lucidlink/dto/web-service-api';
import { arrayParserFromDto } from '#fetcher/parse-utils';
import { prepareInvitationKeyListForMigration } from '#sdk/workspace-client/invitation-manager/prepare-invitations-for-sso';
// eslint-disable-next-line @typescript-eslint/naming-convention -- We want the naming to reflect the migration number
export class Migration_2_EnsureWorkspaceKeySetInAllInvitations {
    adminCrypto;
    workspaceFetcher;
    constructor(adminCrypto, workspaceFetcher) {
        this.adminCrypto = adminCrypto;
        this.workspaceFetcher = workspaceFetcher;
    }
    async shouldExecute() {
        const adminMember = await this.adminCrypto.adminMember.get();
        return (adminMember.workspaceConfig
            ?.m002_workspaceKeySetForAllInvitations !== true);
    }
    async execute() {
        const invitationKeysList = await this.workspaceFetcher.get(['crypto-migration', 'non-ws-key-encrypted-invitations'], {
            parser: arrayParserFromDto(InvitationResponseDto),
        });
        const adminMember = await this.adminCrypto.adminMember.get();
        const privateKeysByWorkspaceKeyListList = await prepareInvitationKeyListForMigration(invitationKeysList, this.adminCrypto, adminMember.workspace.id);
        await this.workspaceFetcher.patch(['crypto-migration', 'non-ws-key-encrypted-invitations'], {
            body: privateKeysByWorkspaceKeyListList,
        });
    }
}
